var UiGroupsModule = /** @class */ (function () {
    function UiGroupsModule() {
    }
    return UiGroupsModule;
}());
export { UiGroupsModule };
